export enum BrowserSupportRequirement {
  Full,
  Partial
}
